import(/* webpackMode: "eager" */ "/app/app/(callback-with-footer)/layout.tsx");
